const COLOR = {
  SINGUP_MAIN : '#0085FD'
}

export default COLOR;